/* import __COLOCATED_TEMPLATE__ from './adi-input.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import PrettyNum from '@ebiz/pretty-num';
import Utils from '../../utils/utils';

const DEFAULT_PRETTY_NUM_TYPE = 'eng3';

export default class AdiInput extends Component {
  @service intl;

  inputValue;

  get displayValue() {
    const values = this.getValues(this.args.value ? this.args.value.toString() : '');
    return (values.raw || values.raw === 0) && values.pretty ? values.pretty : values.raw;
  }

  @action onChange(event) {
    let value = event.target.value;

    const values = this.getValues(value);
    if (!values) return;
    if (!this.args.doNotSetValue) this.inputValue = values.raw;

    let displayValue = (values.raw || values.raw === 0) && values.pretty ? values.pretty : values.raw;
    event.target.value = displayValue;

    if (values.hasChanged && this.args.onValueChange) {
      this.args.onValueChange(values.raw);
    }
  }

  getValues(inputValue) {
    let result = {};

    if (this.args.isPretty) {
      result.raw = PrettyNum.userEntryToNumber(inputValue, NaN);

      if (isNaN(result.raw) && Utils.isNumeric(inputValue)) {
        result.raw = Number(inputValue);
      }

      if (isNaN(result.raw)) {
        result.raw = this.args.value;
        result.errorMessage = this.intl.t('messages.multiplier_numeric');
      } else if (this.args.customValidationFn) this.args.customValidationFn(result, this.args.value);
    } else if (Utils.isNumeric(inputValue)) {
      // Set the precision if provided
      if (this.args.precision && inputValue.includes('.') && inputValue.length - 1 > Number(this.args.precision)) {
        inputValue = inputValue.slice(0, Number(this.args.precision) + (inputValue.startsWith('.') ? 0 : 1));
      }

      result.raw = Number(inputValue);

      if (this.args.customValidationFn) this.args.customValidationFn(result, this.args.value);
    } else if (!isNaN(PrettyNum.userEntryToNumber(inputValue, NaN))) {
      result.errorMessage = this.intl.t('messages.multiplier');
      result.raw = this.args.value;
    } else {
      result.errorMessage = this.intl.t('messages.numeric');
      result.raw = this.args.value;
    }

    if (this.args.isPretty) {
      result.pretty = this.prettyNumFn(result.raw);
    }

    result.hasChanged = !(this.args.value === result.raw);

    return result;
  }

  prettyNumFn(value) {
    const prettyNumType = this.args.prettyNumType || DEFAULT_PRETTY_NUM_TYPE;
    let prettyNumFns = {
      eng3: (value) => PrettyNum.eng3(value),
      eng4: (value) => PrettyNum.eng4(value),
    };
    return prettyNumType in prettyNumFns ? prettyNumFns[prettyNumType](value) : value;
  }
}
